import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import { getI18nInstance as i18n } from '@/i18n';
import { globalParam } from '@/helpers/globals';
import { Event } from './Event';

export const eventClasses = {
    event: {
        value: Event.CLASS_EVENT,
        classValue: Event.CLASS_EVENT,
        labelKey: 'veranstaltung',
        descriptionKey: 'class_event_info_text',
        infoUrlKey: null,
        staffOnly: false,
        genreGroup: true,
    },
    exhibition: {
        value: Event.CLASS_EXHIBITION,
        classValue: Event.CLASS_EXHIBITION,
        labelKey: 'ausstellung',
        descriptionKey: 'class_exhibition_info_text',
        infoUrlKey: 'event.event_class_exhibition_info_url',
        staffOnly: false,
        genreGroup: true,
    },
    cinema: {
        value: Event.CLASS_CINEMA,
        classValue: Event.CLASS_CINEMA,
        labelKey: 'kino',
        descriptionKey: 'class_cinema_info_text',
        infoUrlKey: 'event.event_class_cinema_info_url',
        staffOnly: false,
        genreGroup: true,
    },
    festival: {
        value: Event.CLASS_FESTIVAL,
        classValue: Event.CLASS_FESTIVAL,
        labelKey: 'festival',
        descriptionKey: 'class_festival_info_text',
        infoUrlKey: 'event.event_class_festival_info_url',
        staffOnly: false,
        genreGroup: false,
    },
    /** @see #22829: wird vorerst ausgeblendet */
    /** per 6.11.2023 wird dies eingeblendet (Mailverkehr mit Kunde) */
    tournee: {
        value: Event.CLASS_TOURNEE,
        classValue: Event.CLASS_TOURNEE,
        labelKey: 'tournee',
        descriptionKey: 'class_tournee_info_text',
        infoUrlKey: 'event.event_class_tournee_info_url',
        // siehe #27908: Tournee DOCH wieder ausblenden für Non-Staff-Users. Das war wohl eine Miss-Kommunikation:
        // siehe #16144: Tournee DOCH wieder einblenden für Non-Staff-Users.
        staffOnly: false,
        genreGroup: false,
    },
    permanent_exhibition: {
        value: Event.CLASS_PERMANENT_EXHIBITION,
        classValue: Event.CLASS_PERMANENT_EXHIBITION,
        labelKey: 'dauerausstellung',
        descriptionKey: 'class_permanent_exhibition_info_text',
        infoUrlKey: null,
        staffOnly: false,
        genreGroup: false,
    },
    stream: {
        value: Event.CLASS_STREAM,
        classValue: Event.CLASS_STREAM,
        labelKey: 'stream',
        descriptionKey: 'class_stream_info_text',
        infoUrlKey: null,
        staffOnly: false,
        genreGroup: true,
    },
};

export class EventClass extends BaseModel {
    defaults() {
        return {
            value: null,
            classValue: null,
            label: null,
            description: null,
            staffOnly: true,
            genreGroup: false,
        };
    }

    mutations() {
        return {
            staffOnly: Boolean,
            genreGroup: Boolean,
        };
    }
}

export class EventClassCollection extends BaseCollection {
    options() {
        return {
            model: EventClass,
        };
    }
}

let myEventClasses = null;

export function getEventClasses() {
    if (!myEventClasses) {
        myEventClasses = new EventClassCollection();
        for (const eventClass in eventClasses) {
            const data = eventClasses[eventClass];
            if (!data) {
                continue;
            }
            myEventClasses.add({
                value: data.value,
                classValue: data.classValue,
                label: i18n().t(data.labelKey),
                description: i18n().t(data.descriptionKey, { info_url: globalParam(data.infoUrlKey) }),
                staffOnly: data.staffOnly,
                genreGroup: data.genreGroup,
            });
        }
    }
    return myEventClasses;
}
